import { gql } from "@apollo/client";

export const GET_CLIENTES_CC = gql`
query QGetClientesCC($idDelegacion: Int!) {
    clientesCC (idDelegacion: $idDelegacion) {
        success,
        error,
        valorEsperado {
            cliente,
            codCliente,
            cUIT,
            domicilio,
            cP,
            delegacion,
            usuario,
            fechaAlta
        }
    }
}`;

export const GET_CLIENTES_CC_EXPORT = gql`
query QGetClientesCC($idDelegacion: Int!) {
    clientesCC (idDelegacion: $idDelegacion) {
        success,
        error,
        valorEsperado {
            cliente,
            codCliente,
            cUIT,
            domicilio,
            cP,
            delegacion,
            usuario,
            fechaAlta
        }
    }
}`;

export const GET_CLIENTES_CC_DISPONIBLES = gql`
query QClientesDisponiblesCC($idDelegacion: Int!) {
    clientesDisponiblesCC (idDelegacion: $idDelegacion) {
        success,
        error,
        valorEsperado {
            cliente,
            codCliente,
            cUIT,
            domicilio,
            cP,
            delegacion,
            usuario,
            fechaAlta
        }
    }
}`;